(() => {
  'use strict';
  const expireEntries = () => {
    const now = Date.now();
    document.querySelectorAll('[data-rs-bf-entry-end]').forEach(entry => {
      if (now >= Number(entry.dataset.rsBfEntryEnd)) entry.hidden = true;
    });
  };
  expireEntries();
  window.addEventListener('pageshow', expireEntries);
  document.addEventListener('visibilitychange', expireEntries);
  document.addEventListener('shopify:section:load', expireEntries);
  window.setInterval(expireEntries, 60000);
})();
